import {
  createContext,
  useContext,
  useEffect,
  useState,
  useCallback,
} from "react";
import { ReactNode } from "react";
import {
  IGuest,
  IHU,
  IProductHU,
  IReserve,
  IServiceHU,
  IHUCreate,
} from "../../Interfaces";
import { api, userID } from "../../Services/api";
import { toast } from "react-toastify";

interface HabUnitProviderProps {
  children: ReactNode;
}

interface HabUnitProviderData {
  createHU: (HU: IHUCreate) => void;
  editHU: (HUData: IHU) => void;
  deleteHU: (HU: IHU) => void;
  listHUs: () => void;
  AdmHUList: IHU[];
  addService: (service: IServiceHU, HU: IHU) => void;
  addProduct: (product: IProductHU, HU: IHU) => void;
  removeService: (service: IServiceHU, HU: IHU) => void;
  removeProduct: (product: IProductHU, HU: IHU) => void;
  changeStateTo: (
    state: "available" | "occupied" | "maintenance" | "reserved",
    HU: IHU
  ) => void;
  addDailyRate: (AdmHUList: IHU[]) => void;
  addReserve: (newReserve: IReserve, HU: IHU) => void;
  editReserve: (reserve: IReserve, HU: IHU, newReserveData: IReserve) => void;
  deleteReserve: (reserve: IReserve, HU: IHU) => void;
  // listReserves: (HU: IHU) => void;
  checkIn: (HU: IHU, guest: IGuest[]) => void;
  checkOut: (HU: IHU) => void;
  getTotal: (HU: IHU) => number;
}

export const HabUnitContext = createContext<HabUnitProviderData>(
  {} as HabUnitProviderData
);

export const HabUnitProvider = ({ children }: HabUnitProviderProps) => {
  const [AdmHUList, setAdmHUList] = useState<IHU[]>([]);
  const [HUId, setHUId] = useState<number>(0);
  const [AdmId, setAdmId] = useState<number>(0);
  const [ADDServices, setADDServices] = useState<IServiceHU[]>([]);
  const [ADDProducts, setADDProducts] = useState<IProductHU[]>([]);
  const [manageReserves, setManageReserves] = useState<IReserve[]>([]);
  const [currTime, setCurrTime] = useState<Date | string>(new Date());

  const createHU = (HUData: IHUCreate) => {
    api
      .post("/habUnits", HUData)
      .then((_) => {
        listHUs();
        toast.success("Unidade cadastrada");
      })
      .catch((_) => {
        toast.error("Erro ao cadastrar Unidade");
      });
  };

  const editHU = (HUData: IHU) => {
    const { id } = HUData;
    api
      .patch(`/habUnits/${id}`, HUData)
      .then((_) => {
        listHUs();
        toast.success("Unidade editada");
      })
      .catch((_) => {
        toast.error("Erro ao editar Unidade");
      });
  };

  const deleteHU = (HU: IHU) => {
    const { id } = HU;
    api
      .delete(`/habUnits/${id}`)
      .then((_) => {
        listHUs();
        toast.success("Unidade excluida");
      })
      .catch((_) => {
        toast.error("Erro ao deletar Unidade");
      });
  };

  const listHUs = () => {
    api.get("/habUnits").then((res) => {
      setAdmHUList(res.data);
    });
  };

  //ADD SERVICES//

  const addService = (newService: IServiceHU, HU: IHU) => {
    const { services, id } = HU;
    setHUId(id);
    setADDServices([...services, newService]);
  };

  useEffect(() => {
    if (ADDServices.length !== 0 && HUId !== 0) {
      api
        .patch(`/habUnits/${HUId}`, { services: ADDServices })
        .then((_) => {
          setADDServices([]);
          setHUId(0);
          listHUs();
          toast.success("Servico adicionado ao quarto");
        })
        .catch((_) => {
          toast.error("Erro ao adicionar servico ao quarto");
        });
    }
  }, [ADDServices, HUId]);

  //ADD SERVICES//

  //-----------------*----------------//

  //ADD PRODUCTS//

  const addProduct = (newProduct: IProductHU, HU: IHU) => {
    const { products, id } = HU;
    setHUId(id);
    setADDProducts([...products, newProduct]);
  };

  useEffect(() => {
    if (ADDProducts.length !== 0 && HUId !== 0) {
      api
        .patch(`/habUnits/${HUId}`, { products: ADDProducts })
        .then((_) => {
          listHUs();

          setADDProducts([]);
          setHUId(0);
          toast.success("Produto adicionado ao quarto");
        })
        .catch((_) => {
          toast.error("Erro ao adicionar produto ao quarto");
        });
    }
  }, [ADDProducts, HUId]);

  //ADD PRODUCTS//

  //-------------------*-----------//

  //REMOVE SERVICES//

  const removeService = (serviceToBeRemoved: IServiceHU, HU: IHU) => {
    const { services, id } = HU;
    const firstOcurrence = services.findIndex(
      (el: IServiceHU) =>
        el.id === serviceToBeRemoved.id &&
        el.quantity === serviceToBeRemoved.quantity
    );

    services.splice(firstOcurrence, 1);
    api
      .patch(`/habUnits/${id}`, { services: services })
      .then(() => {
        listHUs();
        toast.success("Servico removido do quarto");
      })
      .catch((_) => {
        toast.error("Erro ao remover servico");
      });
  };

  //REMOVE PRODUCTS//

  const removeProduct = (productToBeRemoved: IProductHU, HU: IHU) => {
    const { products, id } = HU;
    const firstOcurrence = products.findIndex(
      (el: IProductHU) =>
        el.id === productToBeRemoved.id &&
        el.quantity === productToBeRemoved.quantity
    );
    products.splice(firstOcurrence, 1);

    api
      .patch(`/habUnits/${id}`, { products: products })
      .then(() => {
        listHUs();

        toast.success("Produto removido");
      })
      .catch((_) => {
        toast.error("Erro ao remover produto");
      });
  };

  //REMOVE PRODUCTS//

  //-----------------//

  const changeStateTo = (
    state: "available" | "occupied" | "maintenance" | "reserved",
    HU: IHU
  ) => {
    const { id } = HU;
    api
      .patch(`/habUnits/${id}`, { state: state })
      .then((_) => {
        listHUs();
        toast.success("Novo estado do quarto adicionado");
      })
      .catch((_) => {
        toast.error("Erro ao mudar estado");
      });
  };

  //AUTO ADD DAILY RATES//

  const getTimeHoursMinutes = () => {
    const date = new Date();
    const hours = date.getHours();
    const minutes = (date.getMinutes() < 10 ? "0" : "") + date.getMinutes();

    return hours + ":" + minutes;
  };

  const addDailyRate = useCallback((AdmHUList: IHU[]) => {
    for (let index = 0; index < AdmHUList.length; index++) {
      const element = AdmHUList[index];
      const { id } = element;
      if (getTimeHoursMinutes() === "12:00") {
        const lastCharge = new Date(
          element.dailyCharges[element.dailyCharges.length - 1]
        );
        const lastChargePlusOneDay = new Date(
          lastCharge.getTime() + 24 * 60 * 60 * 1000
        ).getDate();
        const today = new Date().getDate();

        if (lastChargePlusOneDay === today) {
          element.dailyCharges.push(new Date().toDateString());
          api
            .patch(`/habUnits/${id}`, { dailyCharges: element.dailyCharges })
            .then((_) => {
              toast.success("Diárias atualizadas");
              listHUs();
            })

            .catch((_) => {
              toast.error("Erro ao deletar Unidade");
            });
        }
      }
    }
  }, []);

  useEffect(() => {
    setTimeout(() => setCurrTime(new Date()), 60000);
    addDailyRate(AdmHUList);
  }, [currTime, AdmHUList, addDailyRate]);

  //AUTO ADD DAILY RATES//

  //---------------------------------//

  //ADD RESERVE//

  const addReserve = (newReserve: IReserve, HU: IHU) => {
    const { reserves, id } = HU;
    setHUId(id);
    setManageReserves([...reserves, newReserve]);
  };

  useEffect(() => {
    if (manageReserves.length !== 0 && HUId !== 0) {
      api
        .patch(`/habUnits/${HUId}`, { reserves: manageReserves })
        .then(() => {
          listHUs();

          setManageReserves([]);
          setHUId(0);
          toast.success("Reserva adicionada");
        })
        .catch((_) => {
          toast.error("Erro ao adicionar reserva");
        });
    }
  }, [manageReserves, HUId]);

  //ADD RESERVE//

  //--------------------------//

  const editReserve = (
    reserve: IReserve,
    HU: IHU,
    newReserveData: IReserve
  ) => {
    const { date, guest } = reserve;
    const { id } = HU;
    const firstOccurrenceIndex = HU.reserves.findIndex(
      (el) => el.date === date && el.guest === guest
    );
    HU.reserves.splice(firstOccurrenceIndex, 1, newReserveData);

    api
      .patch(`/habUnits/${id}`, { reserves: HU.reserves })
      .then((_) => {
        listHUs();
        toast.success("Reserva editada");
      })
      .catch((_) => {
        toast.error("Erro ao editar reserva");
      });
  };

  const deleteReserve = (reserve: IReserve, HU: IHU) => {
    const { date, guest } = reserve;
    const { id } = HU;
    const firstOcurrence = HU.reserves.findIndex(
      (el) => el.date === date && el.guest === guest
    );
    HU.reserves.splice(firstOcurrence, 1);
    api
      .patch(`/habUnits/${id}`, { reserves: HU.reserves })
      .then((_) => {
        listHUs();
        toast.success("Reserva excluida");
      })
      .catch((_) => {
        toast.error("Erro ao excluir reserva");
      });
  };

  const checkIn = (HU: IHU, guests: IGuest[]) => {
    const { id } = HU;
    const currDate = new Date();
    api
      .patch(`/habUnits/${id}`, {
        guests: guests,
        state: "occupied",
        dailyCharges: [currDate],
      })
      .then((_) => {
        listHUs();
        toast.success("Check-in");
      })
      .catch((_) => {
        toast.error("Erro ao realizar check-in");
      });
  };

  const checkOut = (HU: IHU) => {
    const { id } = HU;
    api
      .patch(`/habUnits/${id}`, {
        guests: "",
        state: "available",
        products: [],
        services: [],
        dailyCharges: [],
      })
      .then((_) => {
        listHUs();
        toast.success("Check-out");
      })
      .catch((_) => {
        toast.error("Erro ao realizar check-out");
      });
  };

  //GET TOTAL//

  const reducer = (previousValue: number, currentValue: number) =>
    previousValue + currentValue;

  const ProductsReducer = (array: IProductHU[]) => {
    const values = array.map((item) => item.price * item.quantity);

    return values.reduce(reducer, 0);
  };
  const ServicesReducer = (array: IServiceHU[]) => {
    const values = array.map((item) => item.price * item.quantity);

    return values.reduce(reducer, 0);
  };

  const DailyChargesReducer = (HU: IHU) => {
    const total = HU.dailyCharges.length * HU.price;
    return total;
  };

  const getTotal = (HU: IHU) => {
    const prodsTotal = ProductsReducer(HU.products);
    const servicesTotal = ServicesReducer(HU.services);
    const dailyChargesTotal = DailyChargesReducer(HU);
    const total = prodsTotal + servicesTotal + dailyChargesTotal;
    return total;
  };

  //GET TOTAL//

  return (
    <HabUnitContext.Provider
      value={{
        createHU,
        editHU,
        deleteHU,
        listHUs,
        AdmHUList,
        addService,
        addProduct,
        removeService,
        removeProduct,
        changeStateTo,
        addDailyRate,
        addReserve,
        editReserve,
        deleteReserve,
        getTotal,
        checkIn,
        checkOut,
      }}
    >
      {children}
    </HabUnitContext.Provider>
  );
};

export const useHabUnits = () => useContext(HabUnitContext);
